import axios from 'ps-components/lib/apiClient';
import { useAppState } from '../redux';
import { useQuery } from 'react-query';

type Scope = {
    scope_pk: number
    scope_code: string
    scope_name: string
}

export const useScopes = () => {
    const appState = useAppState()
    const { csrf_timestamp, csrf_token } = appState.session

    const getScopeList = async () => {
        const response = await axios.apiGet(`/api/report-writer/scope/list?_dc=${csrf_timestamp}&publicPublishRights=true&page=1&start=0&limit=25&csrf_token=${csrf_token}&csrf_timestamp=${csrf_timestamp}`)
        return response.data as Scope[]
    }

    const query = useQuery(['scopeList'], getScopeList, { staleTime: Infinity })

    return query
}